import React from 'react'
import styled from 'styled-components';
import useLogin from '../providers/use_login';
import { Form, Button } from 'react-bootstrap';
import Loading from './loading';

const Frame = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 400px;
  `;

const Login = ({onSuccess, style}) => {
  const {login, error, isReady, isBusy} = useLogin()

  if (!isReady) return <Loading />

  return (
    <Frame style={{...style}}>
      <p>Ingresa tus credenciales para iniciar sesión. Sólo es necesario para poder crear propuestas.</p>
      <p>La cuenta de la Biblioteca es independiente de tu cuenta del foro.</p>
      <Form onSubmit={(e) => {
        e.preventDefault()
        login(e.target.elements.email.value, e.target.elements.password.value, onSuccess)
      }}>
        <Form.Group controlId="email">
          <Form.Label>Correo Electrónico</Form.Label>
          <Form.Control disabled={isBusy} type="text" required placeholder="Correo Electrónico" />
          <Form.Text className="text-muted">
            Este correo NO es necesariamente el mismo del foro.
          </Form.Text>
        </Form.Group>

        <Form.Group controlId="password">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control disabled={isBusy} type="password" required placeholder="Contraseña" />
          <Form.Text className="text-muted">
            {error
            ? <span style={{color: 'red'}}>{error}</span>
            : ''}
          </Form.Text>
        </Form.Group>
        {/* <Form.Group controlId="formBasicCheckbox">
          <Form.Check type="checkbox" label="Check me out" />
        </Form.Group> */}
        <Button disabled={isBusy || !isReady} variant="primary" type="submit">
          Ingresar
        </Button>
      </Form>
    </Frame>
  );
};

export default Login